import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faBoxArchive, faTrashCan, faPencil, faEnvelope, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { Prev } from 'react-bootstrap/esm/PageItem';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { ADDSTATIONADDRESS } from '../../../Utils/conts.js';
import { toast } from 'react-toastify';
import ImageUpload from '../../../Components/common/ImageUpload.js';


const StationDetails = ({ rowData, stationID }) => {

    const [show, setShow] = useState(false);
    const modalShow = () => setShow(true)
    const modalClose = () => setShow(false);
    const storedData = rowData.args.Address;
    // const getLocalData = () => {
    //     // const storedData = localStorage.getItem("StationAddress");
    //     const storedData = rowData.args.Address;
    //     const Saddress = storedData ? JSON.parse(storedData) : [];
    //     const uaddress =  Saddress.map(addr => ({ ...addr, selected: false }));
    //     return uaddress;
    // }
    // useEffect(() => {
    //     setAddress(getLocalData());
    // }, []);

    const [inputAddress, setInputAddress] = useState({
        station_address_id: '', handler_name: '', address_1: '', address_2: '', postal_code: '', phone_number: '', email: ''
    });
    const [address, setAddress] = useState(storedData);
    // const dispatch = useDispatch();
    // Validation 
    const validateFormData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!inputAddress.handler_name) {
            toast.error('Handler Name must not be blank');
            isValid = false;
        } else if (!inputAddress.address_1) {
            toast.error('Address must not be blank');
            isValid = false;
        } else if (!inputAddress.postal_code) {
            toast.error('Postal Code must not be blank');
            isValid = false;
        } else if (!inputAddress.phone_number) {
            toast.error('Phone Number must not be blank');
            isValid = false;
            // } else if (!/^\d{10}$/.test(inputAddress.phone_number)) {
            // 
            //     toast.error('Phone Number must be 10 Digits');
            //     isValid = false;
        } else if (!inputAddress.email) {
            toast.error('Email must not be blank');
            isValid = false;
        } else if (!validateEmail(inputAddress.email)) {
            toast.error('Invalid email address');
            isValid = false;
        }
        else {
            return isValid;
        }
    };


    const addAddress = async (e) => {
        if (validateFormData()) {
            e.preventDefault();
            // const newAddressID = Math.floor(Math.random() * 1000000);
            const stationid = rowData.station_id;
            const NewInputAddress = { ...inputAddress, station_id: stationid };
            const updatedAddress = [...address, NewInputAddress];
            // if (updatedAddress) {
            //     dispatch(addAddressData(NewInputAddress)); // Pass sendStationData to addData thunk
            //   }
            if (NewInputAddress) {
                try {
                    const res = await withRFSToken.post(ADDSTATIONADDRESS, NewInputAddress)
                        .then(function (res) {
                            // const innerData = res;
                            if (res.data.response_code == 200) {
                                // reloadGrid();
                                setAddress(res.data.response_data);
                            }
                        });

                } catch (error) {
                    console.error('Error sending request:', error);
                }
                // Dispatch the action to add address data
                // dispatch(addAddressData(NewInputAddress))
                //     .then((response) => {
                //         // Check the response_code and update ready state if needed
                //         // const { response_code, response_data } = response;
                //         
                //         // if (response_code === 200) {
                //         //     // Update ready state or perform any other actions with response_data
                //         //     setAddress([...address, response_data]);
                //         // } else {
                //         //     // Handle other response codes if necessary
                //         // }
                //     })
                //     .catch((error) => {
                //         // Handle errors if the API call fails
                //         console.error('Error adding address data:', error);
                //     });
            }
            // setAddress(updatedAddress);
            // localStorage.setItem('stationAddresses', JSON.stringify(updatedAddress));
            // setAddress([...address, NewInputAddress]);
            setInputAddress({
                handler_name: '', address_1: '', address_2: '', postal_code: '', phone_number: '', email: ''
            });

            modalClose();
        }
    }
    const handleChange = (e) => {
        setInputAddress({ ...inputAddress, [e.target.name]: e.target.value });
    };



    const [selectAddress, setSelectAddress] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [selectedAddressId, setSelectedAddressID] = useState(null);

    const addressDetails = (addressID) => {
        setSelectedAddressID(addressID)
        const updatedSelects = address.map(ads => ({ ...ads, selected: false }));
        const updatedSelect = updatedSelects.find(ads => ads.id === addressID);
        if (updatedSelect) {
            updatedSelect.selected = true;
        }
        setAddress(updatedSelects);
        const selected = address.find((addr) => addr.id === addressID);
        setSelectedAddress(selected);
        setItems(selected?.station_request_emails
            ? JSON.parse(selected.station_request_emails)
            : []);
    };
    //   EDIT SECTION
    const [showEdit, setShowEdit] = useState(false);
    const modalEditShow = () => setShowEdit(true)
    const modalEditClose = () => setShowEdit(false);

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        let changedValue = value;
        if (name === 'sla') {
            changedValue = changedValue.replace(/\D/g, "");
            if (changedValue.length > 2 && changedValue.length <= 4) {
                changedValue = changedValue.slice(0, 2) + ":" + changedValue.slice(2);
            } else if (changedValue.length > 4) {
                changedValue =
                    changedValue.slice(0, 2) +
                    ":" +
                    changedValue.slice(2, 4) +
                    ":" +
                    changedValue.slice(4, 6);
            }
        }
        setSelectedAddress((prev) => ({ ...prev, [name]: changedValue }));
    };
    const editAddress = async (e) => {
        // if (validateFormData()) {
        e.preventDefault();
        // const newAddressID = Math.floor(Math.random() * 1000000);
        // const stationid = rowData.station_id;
        // const NewInputAddress = {...inputAddress, station_id: stationid};
        // 
        // const updatedAddress = [...address, NewInputAddress];
        // if (updatedAddress) {
        //     dispatch(addAddressData(NewInputAddress)); // Pass sendStationData to addData thunk
        //   }
        const stationid = rowData.station_id;
        const NewInputAddress = { ...selectedAddress, station_id: stationid };
        if (NewInputAddress) {
            try {
                const res = await withRFSToken.post(ADDSTATIONADDRESS, NewInputAddress)
                    .then(function (res) {
                        // const innerData = res;
                        // 
                        if (res.data.response_code == 200) {
                            // reloadGrid();
                            setAddress(res.data.response_data);
                            // setSelectedAddress(res.data.response_data);
                            const addId = res.data.response_data?.find(id => id.id === selectedAddressId)

                            // addressDetails(addId.id);
                            setSelectedAddress(addId);
                        }
                    });

            } catch (error) {
                console.error('Error sending request:', error);
            }

            modalEditClose();
        }
        // }
    }
    const [items, setItems] = useState();
    const [editEmail, setEditEmail] = useState('');
    const inputEmailShow = () => setEmailShow(true);
    const [emailShow, setEmailShow] = useState(false);
    const [inputData, setInputData] = useState("");

    const [toggleButton, setToggleButton] = useState(false);
    const handleKeyPress = () => { document.getElementById('addEmail').classList.remove('error'); }
    const EditEmail = (index) => {
        // const email_toedit = items.find((elem) => {
        //     return elem.id == index;
        // });
        setEmailShow(true);
        setToggleButton(true);
        setInputData(items[index]);
        setEditEmail(index);
    }
    const AddEmail = async () => {
        if (inputData == '') {
            document.getElementById('addEmail').classList.add('error');
            toast.error('Email address must not be blank');
            setEmailShow(true);
        }
        else if (inputData && toggleButton) {
            const NewItemData = {
                id: selectedAddress.id,
                email: inputData,
                email_key: editEmail,
            }
            try {
                const res = await withRFSToken.post('station-save-email', NewItemData)
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        setItems(innerData);
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
            setInputData('');
            setEditEmail(null);
            setToggleButton(false);
            setEmailShow(false);
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const validateEmail = (email) => {
                return emailRegex.test(email);
            };
            if (!validateEmail(inputData)) {
                toast.error('Invalid email address');
                setEmailShow(true);
            } else {
                const NewItemData = {
                    // id: new Date().getTime().toString(),
                    id: selectedAddress.id,
                    email: inputData
                }
                try {
                    const res = await withRFSToken.post('station-save-email', NewItemData)
                        .then(function (res) {
                            const innerData = res.data.response_data;
                            setItems(innerData);
                            // setExportGrid(innerData.export);
                        });

                } catch (error) {
                    console.error('Error fetching data:', error);
                }
                // setItems([...items, NewItemData]);
                setEmailShow(false);
            }

            // localStorage.setItem('TruckerEmail', JSON.stringify(NewItemData));
        }
        setInputData('');
        // setEmailShow(false);

    }
    const deleteEmail = async (index) => {
        const updatedItem = items.filter((curElem) => {
            return curElem.id !== index;
        });
        try {
            const res = await withRFSToken.post('station-delete-email', { id: selectedAddress.id, email_key: index })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setItems(innerData);
                    // setExportGrid(innerData.export);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const saveSLA = async (timeValue) => {
        try {
            const res = await withRFSToken.post('add-station-sla', { id: selectedAddress.id, sla: selectedAddress.sla })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    //setItems(innerData);
                    setSelectedAddress((prev) => ({
                        ...prev,
                        sla: innerData?.sla ?? prev.sla,
                    }));
                    setAddress((prevAddresses) =>
                        prevAddresses.map((addr) =>
                            addr.id === selectedAddress.id
                                ? { ...addr, sla: innerData?.sla ?? selectedAddress.sla }
                                : addr
                        )
                    );
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    return (
        <>

            <Row className='mt-3'>
                <Col className='pt-4 px-4 brd_rgt' md="6">
                    <h4>Station Details</h4>
                    <p>Add stations and manage stations by selecting the station.</p>
                    <h3> {rowData.args.STN} </h3>
                    <div className='d-flex justify-content-between pt-3'>
                        <div>
                            <h4>Manage Address </h4>
                            <p>Manage Address and add address</p>
                        </div>
                        <div className='align-self-center'>
                            <button onClick={modalShow} className='add_adres'>+ Add Address</button>
                        </div>

                    </div>
                    <div className='addresses'>
                        {address && address.map((ads, index) => (
                            <>
                                <div key={ads.id} className={`addres_box ${ads.selected ? 'selectbx' : ''} `} onClick={() => addressDetails(ads.id)}>
                                    <ul key={index}>
                                        <h3>{ads.handler_name}</h3>
                                        <li><span>Address </span> : <span>{ads.address_1}</span></li>
                                        <li><span>Address 2 </span> : <span>{ads.address_2}</span></li>
                                        <li><span>Postal code </span> : <span>{ads.postal_code}</span></li>
                                        <li><span>Email </span> : <span>{ads.email}</span></li>
                                        <li><span>Phone No </span> : <span>{ads.phone_number}</span></li>
                                    </ul>
                                    <div className='confrm'><FontAwesomeIcon icon={faCircleCheck} /></div>
                                </div>
                            </>
                        ))}
                    </div>
                </Col>
                <Col className='pt-4 px-4' md="6">
                    {selectedAddress && (
                        <>
                            <div className='handler_name'>
                                <div className='raedit'><Button variant="link" onClick={modalEditShow}><FontAwesomeIcon icon={faPencil} /> Edit</Button></div>
                                <h2>{selectedAddress.handler_name}</h2>

                                <p>Details</p>

                                <div className='handler_info'>
                                    <ul>
                                        <h3>Handler Information</h3>
                                        <li><span>Address </span> : <span>{selectedAddress.address_1}, {selectedAddress.address_2} </span></li>
                                        <li><span>Postal code</span> : <span>{selectedAddress.postal_code}</span></li>
                                        <li><span>Email </span> : <span>{selectedAddress.email}</span></li>
                                        <li><span>Phone No </span> : <span>{selectedAddress.phone_number}</span></li>
                                    </ul>
                                </div>
                                <h3 className='mt-4'>SLA Loading/Unloading</h3>
                                <Form.Group className='mb-2 d-flex saveSla'>
                                    <Form.Control
                                        type="text"
                                        onChange={handleEditChange}
                                        value={selectedAddress.sla || ''}
                                        name='sla'
                                        placeholder="HH:MM:SS"
                                        pattern="^([0-1]\d|2[0-3]):([0-5]\d):([0-5]\d)$"
                                    />
                                    <Button variant="primary mb-0" onClick={saveSLA}>
                                        Save SLA
                                    </Button>
                                </Form.Group>
                                <ImageUpload
                                    attachable_type={"station_handler"}
                                    attachable_id={selectedAddressId}
                                    attachments={selectedAddress.attachments}
                                    group_id={'21'}
                                />
                                <div className='d-flex justify-content-between py-2'>
                                    <h6>Request Email Address</h6>
                                    <div className='align-self-center'>
                                        <button onClick={inputEmailShow} className='add_adres'>+ Add Email</button>
                                    </div>
                                </div>

                                <div className='addresses'>
                                    {emailShow &&
                                        <>
                                            <div className='add_email'>
                                                <input name='' value={inputData} onKeyDown={handleKeyPress} onChange={(e) => setInputData(e.target.value)} id='addEmail' type='text' placeholder='Email type here' />
                                                {toggleButton ? <button onClick={AddEmail}>Edit</button> : <button onClick={AddEmail}><FontAwesomeIcon icon={faPlus} /> Add</button>}
                                            </div>
                                        </>
                                    }
                                    <div className='showItem'>
                                        {items && items.map((elem, index) => {
                                            return (
                                                <div className='eachItem' key={index}>
                                                    <h3><FontAwesomeIcon icon={faEnvelope} /> {elem}</h3>
                                                    {/* <button>Edit</button> */}
                                                    <div className='request_email'>
                                                        <button onClick={() => EditEmail(index)}> <FontAwesomeIcon icon={faPencil} /> </button>
                                                        <button onClick={() => deleteEmail(index)}> <FontAwesomeIcon icon={faTrashCan} /> </button>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        )}
                                    </div>

                                </div>
                            </div>
                            <Modal show={showEdit} onHide={modalEditClose} centered className='addfrom'>
                                <Modal.Header closeButton onClick={modalEditClose}>
                                    <Modal.Title>Edit Address</Modal.Title>
                                </Modal.Header>
                                <Modal.Body >
                                    <Form.Group className='mb-2'>
                                        <Form.Label>Handler Name</Form.Label>
                                        <Form.Control type="text" onChange={handleEditChange} value={selectedAddress.handler_name} name='handler_name' placeholder="Handler Name" />
                                    </Form.Group>
                                    <Form.Group className='mb-2'>
                                        <Form.Label>Address Line 1</Form.Label>
                                        <Form.Control type="text" onChange={handleEditChange} value={selectedAddress.address_1} name='address_1' placeholder="Address" />
                                    </Form.Group>
                                    <Form.Group className='mb-2'>
                                        <Form.Label>Address Line 2</Form.Label>
                                        <Form.Control type="text" onChange={handleEditChange} value={selectedAddress.address_2} name='address_2' placeholder="Address" />
                                    </Form.Group>
                                    <Form.Group as={Row} className='mb-2'>
                                        <Col sm="6">
                                            <Form.Label>Postal Code</Form.Label>
                                            <Form.Control type="text" onChange={handleEditChange} value={selectedAddress.postal_code} name='postal_code' placeholder="Zip" />
                                        </Col>
                                        <Col sm="6">
                                            <Form.Label>Telephone No</Form.Label>
                                            <Form.Control type="number" onChange={handleEditChange} value={selectedAddress.phone_number} maxLength='12' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12); }} name='phone_number' placeholder="Number" />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group className='mb-2'>
                                        <Form.Label>Email ID</Form.Label>
                                        <Form.Control type="text" onChange={handleEditChange} value={selectedAddress.email} name='email' placeholder="E-mail" />
                                    </Form.Group>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="primary" onClick={editAddress}  >
                                        Update Address
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </>
                    )}
                </Col>
            </Row>



            <Modal show={show} onHide={modalClose} centered className='addfrom'>
                <Modal.Header closeButton onClick={modalClose}>
                    <Modal.Title>Add Address</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form.Group className='mb-2'>
                        <Form.Label>Handler Name</Form.Label>
                        <Form.Control type="text" onChange={handleChange} name='handler_name' placeholder="Handler Name" />
                    </Form.Group>
                    <Form.Group className='mb-2'>
                        <Form.Label>Address Line 1</Form.Label>
                        <Form.Control type="text" onChange={handleChange} name='address_1' placeholder="Address" />
                    </Form.Group>
                    <Form.Group className='mb-2'>
                        <Form.Label>Address Line 2</Form.Label>
                        <Form.Control type="text" onChange={handleChange} name='address_2' placeholder="Address" />
                    </Form.Group>
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="6">
                            <Form.Label>Postal Code</Form.Label>
                            <Form.Control type="text" onChange={handleChange} name='postal_code' placeholder="Zip" />
                        </Col>
                        <Col sm="6">
                            <Form.Label>Telephone No</Form.Label>
                            <Form.Control
                                type="number"
                                onChange={handleChange}
                                name='phone_number'
                                maxLength='50'
                                onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 50); }}
                                placeholder="Number"
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group className='mb-2'>
                        <Form.Label>Email ID</Form.Label>
                        <Form.Control type="text" onChange={handleChange} name='email' placeholder="E-mail" />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={addAddress}  >
                        Add Address
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default StationDetails;